import React from 'react';
import Image from '../Image/image-component';

export default function WhatWeDoSection({ sectionData }) {
    const { label, title, lead, items = [], body, image } = sectionData || {};

    return (
        <section className="w-full bg-white py-10 md:py-14 px-5 md:px-6">
            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-center">

                {/* Image */}
                <div className="relative">
                    <div className="absolute -top-2 -left-2 w-12 h-12 bg-secondary-500" />
                    <div className="absolute -bottom-2 -right-2 w-16 h-16 bg-primary-950" />

                    <div className="relative overflow-hidden shadow-md border border-black/10">
                        <Image
                            src={image}
                            alt={title || 'Marine Construction'}
                            className="w-full h-[220px] md:h-[280px] object-cover"
                            useSekeleton={false}
                        />
                    </div>
                </div>

                {/* Content */}
                <div>
                    {label && (
                        <span className="text-secondary-500 font-bold uppercase text-xs tracking-widest mb-3 block">
                            {label}
                        </span>
                    )}

                    {title && (
                        <h2 className="text-2xl md:text-4xl font-black text-primary-950 leading-tight mb-3">
                            {title}
                        </h2>
                    )}

                    {lead && (
                        <p className="text-sm md:text-base text-primary-950/80 mb-4">
                            {lead}
                        </p>
                    )}

                    {items.length > 0 && (
                        <div className="space-y-2 mb-4">
                            {items.map((item, index) => (
                                <div key={index} className="flex items-start gap-2">
                                    <span className="text-secondary-500 font-bold">—</span>
                                    <p className="text-sm md:text-base font-medium text-primary-950">
                                        {item}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}

                    {body && (
                        <p className="text-sm md:text-base text-primary-950/60 leading-relaxed">
                            {body}
                        </p>
                    )}
                </div>

            </div>
        </section>
    );
}